const MAX_FILE_SIZE = 25;

export default Object.freeze({
  MAX_FILE_SIZE,
});
